import { IGrpStandardPageConfig } from "../../../shared/interfaces/IPageConfig";
import { IRessources } from "../../../shared/interfaces/IFeatures";

export const Config: IGrpStandardPageConfig<IRessources> = {
    api: { path: "ressources" },
    fields: {
        id: { label: "Código", fieldType: "number" },
        res_nome: {
            label: "Nome da coluna",
            fieldType: "text",
        },
        res_proveniente: {
            label: "Tabela de origem",
            fieldType: "text",
        },
        created_at: { label: "Criado em", fieldType: "date" },
        updated_at: { label: "Atualizado em", fieldType: "date" },
    },
};
